import { IFIReportType } from '@cims-online/shared'
import { RenderCustomExpandableSubsection } from 'components/CIMSTable/CIMSTableContext/hooks/useExpandableSection/components/ExpandableSection/types'
import { IdentifiedFieldIssue } from '../../IFITrackerContext/types'
import { HelpMessage } from 'utils/constants'

const ConcreteHelp = HelpMessage.Concrete.ConcreteTestSetTracker
const IFIHelp = HelpMessage.IdentifiedFieldIssues.IFITracker

const reportFields = ({
  reportTypeId,
  reportTechnician,
  concreteTest,
  dailyInspectionInspection,
  dailyInspectionPunchList,
  dailyInspectionControlPoint,
  lot,
  densityTest,
}: IdentifiedFieldIssue): RenderCustomExpandableSubsection[] => [
  {
    type: 'fields',
    title: IFIReportType.ConcreteTest.type,
    hidden: reportTypeId !== IFIReportType.ConcreteTest.id,
    fields: [
      {
        label: 'Notes',
        help: ConcreteHelp.Tests.Notes,
        children: concreteTest?.notes,
      },
      {
        label: 'Override',
        help: ConcreteHelp.Tests.OverrideComments,
        children: concreteTest?.overrideComments,
      },
      {
        label: 'Technician',
        help: IFIHelp.ConcreteTests.Technician,
        children: reportTechnician?.technicianName,
      },
      {
        label: 'Placement Type',
        help: ConcreteHelp.Material.PlacementType,
        children:
          concreteTest?.concreteTestSet?.concretePlacements[0]?.placementType,
      },
      {
        label: 'Percent Air',
        help: ConcreteHelp.Tests.PercentAir,
        children: concreteTest?.percentAir,
      },
      {
        label: 'Percent Air Tested By',
        help: ConcreteHelp.Tests.AirTestedBy,
        children: concreteTest?.percentAirTestedBy?.technicianName,
      },
      {
        label: 'Slump',
        help: ConcreteHelp.Tests.Slump,
        children: concreteTest?.slump,
      },
      {
        label: 'Slump Tested By',
        help: ConcreteHelp.Tests.SlumpTestedBy,
        children: concreteTest?.slumpTestedBy?.technicianName,
      },
      {
        label: 'Concrete Temp',
        help: ConcreteHelp.Tests.ConcreteTemp,
        children: concreteTest?.concreteTemp,
      },
      {
        label: 'Concrete Temp Tested By',
        help: IFIHelp.ConcreteTests.ConcreteTempTestedBy,
        children: concreteTest?.concreteTempTestedBy?.technicianName,
      },
    ],
  },
  {
    type: 'fields',
    title: IFIReportType.DailyInspectionInspection.type,
    hidden: reportTypeId !== IFIReportType.DailyInspectionInspection.id,
    fields: [
      {
        label: 'Work Type',
        help: IFIHelp.Inspections.WorkType,
        children: dailyInspectionInspection?.workType?.name,
      },
      {
        label: 'Technician',
        help: IFIHelp.Inspections.Technician,
        children: dailyInspectionInspection?.reviewedBy?.technicianName,
      },
    ],
  },
  {
    type: 'fields',
    title: IFIReportType.DailyInspectionPunchList.type,
    hidden: reportTypeId !== IFIReportType.DailyInspectionPunchList.id,
    fields: [
      {
        label: 'Status Update',
        help: IFIHelp.PunchLists.StatusUpdate,
        children: dailyInspectionPunchList?.statusUpdate,
      },
      {
        label: 'Technician',
        help: IFIHelp.PunchLists.Technician,
        children: dailyInspectionPunchList?.reviewedBy?.technicianName,
      },
    ],
  },
  {
    type: 'fields',
    title: IFIReportType.DailyInspectionControlPoint.type,
    hidden: reportTypeId !== IFIReportType.DailyInspectionControlPoint.id,
    fields: [
      {
        label: 'Work Type',
        help: IFIHelp.ControlPoints.WorkType,
        children: dailyInspectionControlPoint?.workType?.name,
      },
      {
        label: 'Technician',
        help: IFIHelp.ControlPoints.Technician,
        children: dailyInspectionControlPoint?.reviewedBy?.technicianName,
      },
    ],
  },
  {
    type: 'fields',
    title: IFIReportType.Lot.type,
    hidden: reportTypeId !== IFIReportType.Lot.id,
    fields: [
      {
        label: 'Proctor Value',
        help: IFIHelp.DensityLots.ProctorValue,
        children: lot?.globalProctorValue,
      },
      {
        label: 'Average Compaction',
        help: IFIHelp.DensityLots.AverageCompaction,
        children: lot?.compactionAverage,
      },
      {
        label: 'Lot Compaction Requirement',
        help: IFIHelp.DensityLots.LotCompactionRequirement,
        children: lot?.material?.lotCompactionRequirement,
      },
      {
        label: 'Technician',
        help: IFIHelp.DensityLots.Technician,
        children: lot?.createdUser,
      },
    ],
  },
  {
    type: 'fields',
    title: IFIReportType.DensityTest.type,
    hidden: reportTypeId !== IFIReportType.DensityTest.id,
    fields: [
      {
        label: 'Average Percent',
        help: IFIHelp.DensityTests.AveragePercent,
        children: densityTest?.averagePercent,
      },
      {
        label: 'Lot Average Compaction',
        help: IFIHelp.DensityLots.AverageCompaction,
        children: densityTest?.lot?.compactionAverage,
      },
      {
        label: 'Lot Compaction Requirement',
        help: IFIHelp.DensityLots.LotCompactionRequirement,
        children: densityTest?.lot?.material?.lotCompactionRequirement,
      },
      {
        label: 'Technician',
        help: IFIHelp.DensityTests.Technician,
        children: densityTest?.createdUser,
      },
    ],
  },
]

export default reportFields
